import { render, staticRenderFns } from "./ClickFunnels.vue?vue&type=template&id=19ffb4ca"
import script from "./ClickFunnels.vue?vue&type=script&lang=ts"
export * from "./ClickFunnels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports